import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontRow = makeShortcode("DoDontRow");
const DoDont = makeShortcode("DoDont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Anatomy`}</h2>
    <p>{`The basic element of a button is a label. Labels inform users of the action that will occur if they click the button.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button1.svg",
      "alt": "anatomy button guideline"
    }}></img>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Icons left or right :`}</strong>{` Icon that can be positioned either before (leading) or after (trailing) the Label.`}</li>
      <li parentName="ol"><strong parentName="li">{`Text labels :`}</strong>{` The text attributed to the Button that provides context.`}</li>
      <li parentName="ol"><strong parentName="li">{`Container :`}</strong>{` Box from label, icon and as clickable area of button.`}</li>
    </ol>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button2.svg",
      "alt": "button guideline"
    }}></img>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Icons :`}</strong>{` Icon that positioned the centre of the container. If you are using an Icon Button an icon should always be supplied..`}</li>
      <li parentName="ol"><strong parentName="li">{`Container :`}</strong>{` Box from icon and as clickable area of button.`}</li>
    </ol>
    <br />
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button3.svg",
      "alt": "button guideline"
    }}></img>
    <p>{`Button can consist of an icon on its own or an icon paired with a text label. Always ensure that the icon you select for your label clearly communicates the label action. Icons paired with text labels should directly support the text label.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont type="do" captionTitle="Do : With icon" caption="Use direct and concise button labels with short label with one of icon to provide the label context" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button4.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't : With multiple icon" caption="Use multiple icons or unnecessarily long button labels make the users confused mean the action in button" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button41.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>
    <div className="divi" />
    <h2>{`Usage`}</h2>
    <p>{`Buttons allow users to make choices, take actions, and help guide around an interface with a single tap. Buttons also allows user to communicate actions that users can take. They are typically placed throughout your User Interface.`}</p>
    <p><strong parentName="p">{`Common places buttons appear:`}</strong>{` Dialogs, Forms, Toolbars, etc.`}</p>
    <div className="row1">
  <div className="double-column1 mb-2" style={{
        "justifyContent": "flex-start",
        "flex": "1"
      }}>
    <p className="text-xl font-bold mb-2" style={{
          "color": "#429777"
        }}>
      When to use
    </p>
    <ul>
      <li> To display several details about a single idea.</li>
      <li> To use common visual cues (icons and colors) to help users scan the details. </li>
    </ul>
  </div>
  <div className="column1 mb-2" style={{
        "justifyContent": "flex-start",
        "flex": "1"
      }}>
    <p className="text-xl font-bold mb-2" style={{
          "color": "#e42313"
        }}>
      When not to use
    </p>
    <ul>
      <li> When you have many actions at once. </li>
      <li> You want to offer a less important action. </li>
      <li> To make text inside paragraphs or lists actionable. </li>
    </ul>
  </div>
    </div>
    <div className="divi" />
    <h2>{`Accessibility`}</h2>
    <p>{`A button is a box area or text that communicates and triggers user actions when clicked or selected. Buttons are interactive elements.In this layout a Solid button is used to call out a primary action while a Ghost button is used to call out a secondary action.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont type="do" captionTitle="Do : With Different Variant" caption="Use buttons with different variant to convey actions with different levels of importance" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button5.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't : With Same Variant" caption="Use same variant between to convey actions with different levels of importance" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button6.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>
    <h3><strong parentName="h3">{`Margin and Padding`}</strong></h3>
    <p>{`Buttons with text and text with labels have a minimum width of 107 pixels. Wider buttons and buttons with an icon only label must maintain a minimum 16 pixel padding on the left and right. This ensures that the label is legible and clear. In special cases, such as with loader labels, additional padding to the right is required.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button7.svg",
      "alt": "button margin and padding"
    }}></img>
    <div className="divi" />
    <h2>{`Content`}</h2>
    <p>{`Labels should be concise and informative so that users know what action will be triggered when they click the button. Icon-only labels can be used in situations where an icon alone is sufficient to communicate button actions, otherwise we suggest using a text only label or an icon and text label. When writing button labels:`}</p>
    <ul>
      <li parentName="ul">{`Be specific and clearly communicate the button’s action.`}</li>
      <li parentName="ul">{`Use simple verbs or verb phrases.`}</li>
      <li parentName="ul">{`Aim for short labels when possible (1–3 words), to avoid wrapping.`}</li>
      <li parentName="ul">{`Add an icon to the button to call a user’s attention to it or to clarify the button’s action.`}</li>
      <li parentName="ul">{`Avoid punctuation on buttons.`}</li>
    </ul>
    <DoDontRow mdxType="DoDontRow">
  <DoDont type="do" captionTitle="Do : With short copy" caption="Use direct and concise button labels" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button8.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't : With long copy" caption="Use unnecessarily long button labels" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/button/button9.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      